import { render, staticRenderFns } from "./OrgTreeNode.vue?vue&type=template&id=5d517546&"
import script from "./OrgTreeNode.vue?vue&type=script&lang=js&"
export * from "./OrgTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports